import { FirebaseCrashlytics } from "@capacitor-firebase/crashlytics";
import { Capacitor } from "@capacitor/core";
import * as StackTrace from "stacktrace-js";


export const isEnabled = async () => {
    if (Capacitor.isNativePlatform()) {
        const { enabled } = await FirebaseCrashlytics.isEnabled();
        return enabled;
    }
};

export const sendUnsentReports = async () => {
    if (Capacitor.isNativePlatform()) {
        await FirebaseCrashlytics.sendUnsentReports();
    }
};

export const setEnabled = async (value) => {
    if (Capacitor.isNativePlatform()) {
        await FirebaseCrashlytics.setEnabled({
            enabled: value,
        });
    }
};

export const setUserId = async (userId) => {
    if (Capacitor.isNativePlatform()) {
        await FirebaseCrashlytics.setUserId({
            userId: `${userId}`,
        });
    }
};

export const setContext = async (key, value, type = 'string') => {
    if (Capacitor.isNativePlatform()) {

        const processedValue = type === 'boolean'
            ? (typeof value === 'boolean' ? value : Boolean(value))
            : (typeof value === 'string' ? value : String(value));

        await FirebaseCrashlytics.setCustomKey({
            key: key,
            value: processedValue,
            type: type,
        });
    }
};

export const addLogMessage = async (message) => {
    if (Capacitor.isNativePlatform()) {
        await FirebaseCrashlytics.log({
            message: typeof message === 'string' ? message : JSON.stringify(message),
        });
    }
};

export const handleCrash = async (error) => {
    if (Capacitor.isNativePlatform()) {
        await FirebaseCrashlytics.crash({ message: "Test crash" });
    }
};

export const recordExceptionWithStacktrace = async (error, message = "This is a non-fatal message.") => {
    if (Capacitor.isNativePlatform()) {
        const stacktrace = await StackTrace.fromError(error);
        await FirebaseCrashlytics.recordException({
            message,
            stacktrace,
        });
    }
};
